import validate from '../../../services/reduxValidate.js'

export default function (data) {
  return validate(data, {
    firstname: {presence: {allowEmpty: false}},
    lastname: {presence: {allowEmpty: false}},
    email: {
      email: true,
      presence: {allowEmpty: false}
    },
    phone: {
      presence: {allowEmpty: false},
      format: {
        pattern: /^\+?([0-9.\-\s]+)$/g,
        message: "Le numéro de téléphone est invalide"
      },
    },
    universe: {presence: {allowEmpty: false}},
    contact_firstname: {presence: {allowEmpty: false}},
    contact_lastname: {presence: {allowEmpty: false}},
    contact_email: {
      email: true,
      presence: false
    },
    contact_tel: {
      format: {
        pattern: /^\+?([0-9.\-\s]+)$/g,
        message: "Le numéro de téléphone est invalide"
      },
      presence: false,
    },
    contact_job: {presence: {allowEmpty: false}},
    company: {presence: {allowEmpty: false}},
    cgu_accepted: {
      presence: {
        message: 'Vous devez accepter les CGU pour être rémunéré contre informations !'
      },
      inclusion: {
        within: [true],
        message: 'Vous devez accepter les CGU pour être rémunéré contre informations !'
      }
    },
  })
}